export default function Details({product}){
  const details = product.details;

  if(details === undefined) return <div></div>;
  
  const detailInfo = details.detailInfo?? [];
  const table = details.table?? <div/>;

  return(
    <div>
      {details.img!==undefined && details.img!=null && details.img!==''?
        <img src={details.img} alt='detail info'/>
      :null}
      <div className="my-6">
      {detailInfo.map((info, index)=> (
        <div key={index}  className="flex flex-row mb-1">
          <p className="mr-1.5 text-xs lg:text-sm text-gray-400">-</p>
          <p className="text-xs text-gray-400 lg:text-sm">{info}</p>
        </div>
      )
      )}
      </div>
      {/* Table 은 구성이 통일되지 않아서 Children으로 완성된 테이블을 받아 삽입 */}
      {table}
    </div>
  );
}